<template>
  <div class="login-page-bg">
    <div class="content">
      <div class="container">
        <div class="row">
          <!-- <div class="maintenance">
            <h2>The Restaurant Portal is temporarily down for maintenance. We will be back shortly.</h2>
          </div> -->
          <div class="login-wrapper col-xs-12 col-md-4">
            <h3>Restaurant Portal - Login</h3>
            <p v-if="$route.query.redirect">
              You must login first.
            </p>
            <form @submit.prevent="login">
              <label><input v-model="email" placeholder="email"></label>
              <label><input v-model="password" placeholder="password" type="password"></label>
              <button class="btn btn-primary btn-fill btn-wd" type="submit">login</button>
              <p v-if="error" class="error">Invalid login credentials</p>
            </form>
          </div>
          <div class="powered-by">
            <img src="static/img/powered_by.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from 'src/auth'
export default {
  data () {
    return {
      email: '',
      password: '',
      error: false
    }
  },
  methods: {
    login () {
      auth.login(this.email, this.password, loggedIn => {
        if (!loggedIn) {
          this.error = true
        } else {
          // this.$router.replace('/account-settings')
          window.location.href = '/account-settings'
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page-bg {
  min-height: 100vh;
  position: relative;
  background: #0347a6;
}
.powered-by {
    margin: 50px auto 0;
  }
.error {
  color: red;
}
.login-wrapper {
  /* width: 385px; */
  padding: 30px;
  margin: 20px auto;
  background: #f5f5f5;
  border: 1px solid;
  border-radius: 5px;
  float: none !important;
}
.login-wrapper input {
  width: 100%;
  margin: 5px 0;
}
.login-wrapper label {
  width: 100%;
}
.maintenance {
  color: #fff;
  text-align: center;
  width: 50%;
  margin: 10% auto 0;
}
</style>



// WEBPACK FOOTER //
// Login.vue?2f144162